<template>
  <div>
    <div class="text-left mb-5">
      <span class="headline" id="headerlist">Supplier List</span>
    </div>
    <!-- Table Start -->
    <div class="holder">
      <div class="filter">
        <v-text-field
          v-model="filter"
          v-on:keyup="filterList"
          label="search by company name"
          append-icon="mdi-filter"
        />
      </div>
      <div class="paginate">
        <v-select
          v-model="paginationcount"
          v-on:change="paginateList"
          :items="paginationcounts"
          item-text="name"
          item-value="name"
          :selected="paginationcounts.value === 10"
          label="show by"
        ></v-select>
      </div>
    </div>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Company Name</th>
            <th class="text-left">Contact Person</th>
            <th class="text-left">Email Address</th>
            <th class="text-left">Contact Numbers</th>
            <th class="text-left">Address</th>
            <th class="text-left">Web Address</th>
            <th class="text-left">Supplier Code</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in suppliers" :key="item.id" @click="showSupplier(item.id)">
            <td class="text-left">{{ item.company_name }}</td>
            <td class="text-left">{{ item.contact_person }}</td>
            <td class="text-left">{{ item.email_address }}</td>
            <td class="text-left">{{ item.contact_number }}</td>
            <td class="text-left">{{ item.address }}</td>
            <td class="text-left">{{ item.web_address }}</td>
            <td class="text-left">{{ item.supplier_code }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="7" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <v-btn
      fixed
      bottom
      right
      @click="$router.push('/supplier/create')"
      color="blue darken-2"
      dark
      fab
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <supplierCreate
      v-if="create"
      :page="page"
      :create="create"
      @createChange="
        value => {
          this.create = value;
        }
      "
    />
    <supplierEdit v-if="edit" :page="page" :edit="edit" />
    <supplierShow v-if="show" :show="show" :page="page" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import supplierCreate from './SupplierCreate';
import supplierEdit from './SupplierEdit';
import supplierShow from './SupplierShow';

export default {
  data: function() {
    return {
      page: 1,
      filter: '',
      paginationcount: '10'
    };
  },
  components: {
    supplierCreate,
    supplierEdit,
    supplierShow
  },
  props: {
    create: false,
    show: false,
    edit: false
  },
  watch: {
    page(val) {
      this['Supplier/fetchSuppliers']({
        page: val,
        filter: this.filter,
        paginationcount: this.paginationcount
      });
    },
    $route(to, from) {
      if (this.show) {
        this['Supplier/getSupplier']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      suppliers: state => state.Supplier.suppliers.data,
      paginationcounts: state => state.Unit.paginationcount,
      pagination: state => {
        if (state.Supplier.suppliers.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        return state.Supplier.suppliers;
      }
    })
  },
  mounted() {
    this['Supplier/fetchSuppliers']({ page: this.page, paginationcount: this.paginationcount });
  },
  methods: {
    ...mapActions(['Supplier/fetchSuppliers', 'Supplier/getSupplier']),
    showSupplier(id) {
      let path = `/supplier/${id}`;
      if (this.$route.path !== path) this.$router.push(path);
    },
    filterList() {
      if (this.page !== 1) this.page = 1;
      else
        this['Supplier/fetchSuppliers']({
          page: this.page,
          filter: this.filter,
          paginationcount: this.paginationcount
        });
    },
    paginateList() {
      if (this.page !== 1) this.page = 1;
      else this['Supplier/fetchSuppliers']({ page: 1, paginationcount: this.paginationcount });
    }
  }
};
</script>
